import axios from 'axios';

export const getEvents = () => axios({
  url: `${process.env.REACT_APP_API_HOST}/event`,
  method: 'GET',
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  }
}).then(response => response.data.data)


export const getEvent = (cacheKeyBase, cacheKeyId) => {
  return axios({
      url: `${process.env.REACT_APP_API_HOST}/event/${cacheKeyId}`,
      method: 'GET',
      headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}` || ""
      }
  }).then(response => response.data.data)
}

export const postEvent = ({ event }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/event`,
  method: 'POST',
  data: event,
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  }, 
}).then(response => response.data.data);


export const putEvent = ({ _id, event }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/event/${_id}`,
  method: 'PATCH',
  data: event,
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  },
}).then(response => response.data.data);


export const deleteEvent = ({ _id }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/event/${_id}`,
  method: 'DELETE',
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  },
}).then(response => response.data.data);